// const TindakLanjut = () => import('@/views/modules/tindakLanjut/index.vue')
const Report = (resolve) => {
  require.ensure(["@/views/modules/report/index.vue"], () => {
    resolve(require("@/views/modules/report/index.vue"));
  });
};

const routeModTindakLanjut = {
  path: "report",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  meta: {
    allowedUser: [2, 3, 4, 5, 6],
  },
  children: [
    {
      path: "",
      name: "report",
      component: Report,
      meta: {
        requiresUser: true,
        reload: true,
      },
    },
  ],
};

export default routeModTindakLanjut;
